import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthContext';

export function RequireAuth({ children }: { children: JSX.Element }): JSX.Element {
  const { t } = useTranslation();
  const { credentials, user, loading } = useAuth();
  const location = useLocation();
  if (!credentials) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (loading || !user) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        {t('common.loading')}
      </div>
    );
  }
  return children;
}
